const LAST_UPDATED = "2026-09-19";
const SECURITY_EMAIL = "security@shuwa.app";

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-montserrat text-lg font-semibold text-slate-900">{title}</h2>
      <div className="mt-2 space-y-3">{children}</div>
    </section>
  );
}

export default function SecurityPolicy() {
  return (
    <>
      <div className="flex flex-wrap items-center gap-3 border-b border-border pb-6">
        <span className="inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold text-primary">
          Last updated {LAST_UPDATED}
        </span>
        <p className="m-0 text-sm text-slate-500">
          How we protect SHUWA and how to report a vulnerability.
        </p>
      </div>

      <p>
        SHUWA takes the security of our platform, our business owners, and
        their customers seriously. This page explains how we approach
        security and how to responsibly report a vulnerability if you find
        one.
      </p>

      <Section title="Reporting a vulnerability">
        <p>
          If you believe you have found a security vulnerability in SHUWA,
          please report it to{" "}
          <a href={`mailto:${SECURITY_EMAIL}`} className="font-medium text-primary hover:underline">
            {SECURITY_EMAIL}
          </a>{" "}
          with as much detail as possible, including steps to reproduce,
          the impact, and any proof-of-concept material. We aim to
          acknowledge reports within 3 business days.
        </p>
      </Section>

      <Section title="Responsible disclosure guidelines">
        <ul className="list-disc space-y-2 pl-5 marker:text-primary">
          <li>Give us a reasonable amount of time to investigate and fix an issue before disclosing it publicly.</li>
          <li>Do not access, modify, or delete data that isn't yours.</li>
          <li>Do not perform testing that could degrade service for other users, such as denial-of-service attacks or spam.</li>
          <li>Only test against accounts and data you own or have explicit permission to use.</li>
          <li>Avoid automated scanning that generates significant traffic without prior coordination with our team.</li>
        </ul>
      </Section>

      <Section title="What we ask you not to do">
        <p>
          Please avoid social engineering, phishing, or physical attacks
          against SHUWA staff, business owners, or customers, and do not
          attempt to access accounts that are not your own.
        </p>
      </Section>

      <Section title="Our commitment">
        <p>
          We investigate every report in good faith. We will not pursue
          legal action against researchers who follow these guidelines and
          make a good-faith effort to avoid privacy violations and service
          disruption while testing.
        </p>
      </Section>

      <Section title="Platform protections">
        <ul className="list-disc space-y-2 pl-5 marker:text-primary">
          <li>Payments are processed by mobile money providers (MTN Mobile Money and Airtel Money); SHUWA never sees or stores your mobile money PIN.</li>
          <li>Data in transit is encrypted using HTTPS/TLS.</li>
          <li>Access to production systems is limited to authorized personnel.</li>
        </ul>
      </Section>

      <p>
        Questions about this policy can be sent to{" "}
        <a href={`mailto:${SECURITY_EMAIL}`} className="font-medium text-primary hover:underline">
          {SECURITY_EMAIL}
        </a>.
      </p>
    </>
  );
}
